import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { DetailedStockInfo } from '@/pages/DetailedStock/types';

type UpdateMultipleContainerReleaseStatusArgs = {
  liberadoHasta: Date | null;
  recibirHasta: Date | null;
  playa?: string | null;
  estado: string | null;
  observacionesComprobante: string;
  observaciones: string;
  oidImport: number[];
};

type UpdateMultipleContainerReleaseStatusResponse = {
  state: number;
  value: DetailedStockInfo[];
};

export const updateMultipleContainerReleaseStatus = async ({
  liberadoHasta,
  recibirHasta,
  playa,
  estado,
  observaciones,
  observacionesComprobante,
  oidImport,
}: UpdateMultipleContainerReleaseStatusArgs): Promise<DetailedStockInfo[]> => {
  try {
    const res =
      await apiClient.post<UpdateMultipleContainerReleaseStatusResponse>(
        Endpoints.UpdateReleaseStatuses,
        {
          oidImport,
          liberadoHasta,
          recibirHasta,
          playa,
          estado,
          observaciones,
          observacionesComprobante,
        }
      );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
